// extracted by mini-css-extract-plugin
module.exports = {"salesLeaderIcon":"_02712f2b3b--salesLeaderIcon--Djsvj"};